import React from "react";
import PageHeader from "../../../components/ui/page header/PageHeader";
import { useTranslation } from "react-i18next";
import ReferencesSection from "./components/referencesSection/ReferencesSection";

function ReferencesPage() {
  const { t } = useTranslation("references");

  return<>
    <PageHeader
      topic={t("pageHeader.topic")}
      topicSentence={t("pageHeader.topicSentence")}
    />
    <ReferencesSection/>
  </>;
}

export default ReferencesPage;
